import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./homepage/homepage.module").then((m) => m.HomepageModule),
  },
  {
    path: "form",
    loadChildren: () => import("./form/form.module").then((m) => m.FormModule),
  },

  {
    path: "power-bi/:id",
    loadChildren: () =>
      import("./power-bi/power-bi.module").then((m) => m.PowerBiModule),
  },
  {
    path: "dashboards/:id/:keyword",
    loadChildren: () =>
      import("./dashboards/dashboards.module").then((m) => m.DashboardsModule),
    data: {
      title: "dashboards",
      description: "Description Meta Tag Content",
      ogUrl: "your og url",
    },
  },
  {
    path: "unsubscribe",
    loadChildren: () =>
      import("./unsubscribe/unsubscribe.module").then(
        (m) => m.UnsubscribeModule
      ),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "password",
    loadChildren: () =>
      import("./password/password.module").then((m) => m.PasswordModule),
  },
  {
    path: "reset-password",
    loadChildren: () =>
      import("./resetpassword/resetpassword.module").then(
        (m) => m.ResetpasswordModule
      ),
  },
  {
    path: "new-password/:token",
    loadChildren: () =>
      import("./newpassword/newpassword.module").then(
        (m) => m.NewpasswordModule
      ),
  },
  {
    path: "verification-code/:path",
    loadChildren: () =>
      import("./verification-code/verification-code.module").then(
        (m) => m.VerificationCodeModule
      ),
  },
  {
    path: "create-account",
    loadChildren: () =>
      import("./create-account/create-account.module").then(
        (m) => m.CreateAccountModule
      ),
  },
  // {
  //   path: "profile",
  //   loadChildren: () =>
  //     import("./profile/profile.module").then((m) => m.ProfileModule),
  // },
  {
    path: "profile",
    children: [
      {
        path: "edit-profile",
        loadChildren: () =>
          import("./edit-profile/edit-profile.module").then(
            (m) => m.EditProfileModule
          ),
      },
      {
        path: "favorite",
        loadChildren: () =>
          import("./favorite/favorite.module").then((m) => m.FavoriteModule),
      },
      {
        path: "payment-cards",
        loadChildren: () =>
          import("./payment-cards/payment-cards.module").then(
            (m) => m.PaymentCardsModule
          ),
      },
      {
        path: "plans",
        loadChildren: () =>
          import("./plans/plans.module").then((m) => m.PlansModule),
      },
      {
        path: "change-profile",
        loadChildren: () =>
          import("./change-profile/change-profile.module").then(
            (m) => m.ChangeProfileModule
          ),
      },
      {
        path: "subscription-details",
        loadChildren: () =>
          import("./subscription-details/subscription-details.module").then(
            (m) => m.SubscriptionDetailsModule
          ),
      },
      {
        path: "invoices",
        loadChildren: () =>
          import("./invoices/invoices.module").then((m) => m.InvoicesModule),
      },
    ],
  },

  { path: "profile", redirectTo: "/profile/edit-profile", pathMatch: "full" },
  {
    path: "security-password/:path",
    loadChildren: () =>
      import("./security-password/security-password.module").then(
        (m) => m.SecurityPasswordModule
      ),
  },
  {
    path: "small-footer",
    loadChildren: () =>
      import("./small-footer/small-footer.module").then(
        (m) => m.SmallFooterModule
      ),
  },
  {
    path: "plans-packages",
    loadChildren: () =>
      import("./plans-packages/plans-packages.module").then(
        (m) => m.PlansPackagesModule
      ),
  },
  {
    path: "create-dashboard",
    loadChildren: () =>
      import("./create-dashboard/create-dashboard.module").then(
        (m) => m.CreateDashboardModule
      ),
  },
  {
    path: "sent-successfully",
    loadChildren: () =>
      import("./sent-successfully/sent-successfully.module").then(
        (m) => m.SentSuccessfullyModule
      ),
  },
  {
    path: "cancel-subscription/:token",
    loadChildren: () =>
      import("./cancel-subscription/cancel-subscription.module").then(
        (m) => m.CancelSubscriptionModule
      ),
  },
  {
    path: "payment-summary/:plan/:pay",
    loadChildren: () =>
      import("./payment-summary/payment-summary.module").then(
        (m) => m.PaymentSummaryModule
      ),
  },
  {
    path: "subscribed-successfully",
    loadChildren: () =>
      import("./subscriped-successfully/subscriped-successfully.module").then(
        (m) => m.SubscripedSuccessfullyModule
      ),
  },
  {
    path: "exclusive-dashboards",
    loadChildren: () =>
      import("./exclusive-dashboards/exclusive-dashboards.module").then(
        (m) => m.ExclusiveDashboardsModule
      ),
  },

  {
    path: "**",
    loadChildren: () =>
      import("./homepage/homepage.module").then((m) => m.HomepageModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
